// Footer.tsx
import React from 'react';

const Contact: React.FC = () => {
  return (
    <footer style={{ backgroundColor: '#3d5d38', color: '#fff', padding: '2rem 1rem' }}>
      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          gap: '2rem',
        }}
      >
        {/* Brand Info */}
        <div style={{ flex: '1 1 200px' }}>
          <h3 style={{ fontWeight: 'bold' }}>Cerón's Honung</h3>
          <p style={{ marginTop: '0.5rem' }}>
            Omsorgsfull honung med familjär känsla. <br />
            Vi producerar högkvalitativ honung med fokus på binas välbefinnande och miljön.
          </p>
        </div>

        {/* Contact Info */}
        <div style={{ flex: '1 1 200px' }}>
          <h4 style={{ fontWeight: 'bold' }}>Kontakta oss</h4>
          <p>Örsundsbro, Uppsala</p>
          <p>Email: ceronhonung@gmail.com</p>
          <p>Vi nås även via Instagram</p>
        </div>

        {/* Social Media */}
        <div style={{ flex: '1 1 200px' }}>
          <h4 style={{ fontWeight: 'bold' }}>Följ oss</h4>
          <div style={{ display: 'flex', gap: '1rem', marginTop: '0.5rem', justifyContent: 'center' }}>
            <a href="https://facebook.se" target="_blank" rel="noreferrer" style={{ color: '#fff' }}>
                  <img
                    src="/pictures/assets/2023_Facebook_icon.svg.png" // Replace with the actual path to your Instagram icon
                    alt="Facebook"
                    style={{ width: '1.5rem', height: '1.5rem' }}
                  />
            </a>
            <a href="https://instagram.com/ceronhonung" target="_blank" rel="noreferrer" style={{ color: '#fff' }}>
                  <img
                    src="/pictures/assets/Instagram_logo_2016.svg.png" // Replace with the actual path to your Instagram icon
                    alt="Instagram"
                    style={{ width: '1.5rem', height: '1.5rem' }}
                  />
            </a>
          </div>
        </div>
      </div>

      <hr style={{ borderColor: 'rgba(255,255,255,0.2)', margin: '2rem 0' }} />

      <div style={{ textAlign: 'center', color: '#ddd', fontSize: '0.875rem' }}>
        © {new Date().getFullYear()} Cerón's Honung. Alla rättigheter förbehållna.
      </div>
    </footer>
  );
};

export default Contact;
